module.exports = __webpack_public_path__ + "static/media/hands_09.3716b6af.svg";